<template>
  <div class="app">
    <AppHeader v-if="" fixed style="background-color: #428bca">
      <SidebarToggler class="d-lg-none" display="md" mobile/>
      <b-link class="navbar-brand" to="#" style="color: #fff; font-weight: bold; width: 155px;">
        BIS-Office
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg"/>
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none" style="margin-right: 12px" @click="login">
          <b-row>
            <b-col style="padding-right: 8px">
              <i class="icon-user" style="color: #fff;"></i>
            </b-col>
            <b-col style="padding-left: 0;">
            <p style="margin-bottom: 0">Anmelden</p>
            </b-col>
          </b-row>
        </b-nav-item>
      </b-navbar-nav>
    </AppHeader>
    <div :class="{'app-body': true,} " style="overflow: hidden">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav" v-if="renderComponent"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer ref="minimize"/>
      </AppSidebar>
      <main class="main" style="background-color: #fff">
        <div class="container-fluid" style="padding: 0px; height: 100%">
          <inbox-dummy/>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import nav_admin from '@/_nav_admin'
import {
  Header as AppHeader,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from '@coreui/vue'
import {
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
} from '../custom_core_ui'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DownloadWindowsDropdown from './DownloadWindowsDropdown'
import ChangeModuleDropdown from './ChangeModuleDropdown'
import ChangeSuiteDropdown from './ChangeSuiteDropdown'
import InboxDummy from "@/containers/InboxDummy.vue";
import {Cookie_Path} from "@/shared/utils";


export default {
  name: 'DefaultContainer',
  components: {
    ChangeModuleDropdown,
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DownloadWindowsDropdown,
    ChangeSuiteDropdown,
    InboxDummy
  },

  created: function () {
    let nav = [];
    nav.push(nav_admin.items_dummy.header);
    nav.push(nav_admin.items_dummy.inbox);
    nav.push(nav_admin.items_dummy.chat);
    nav.push(nav_admin.items_dummy.auftraege);
    this.nav = nav;
    this.renderComponent = true;
  },
  data() {
    return {
      nav: [],
      renderComponent: false,
    }
  },
  methods: {
    log(e) {
      console.log(e);
    },
    login() {
      try {
        windowsLoginService.onLogin();
      } catch (e) {
        console.log(e);
      }
    }
  },
  computed: {
    name() {
      return this.$route.name
    },
    list() {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }

  }
}
</script>

<style>
.dropdown-menu-right {
  right: 0 !important;
  left: auto !important;
  transform: none!important;
  top: 100% !important;
}
</style>

<style scoped>

::v-deep .sidebar .nav-link.active {
  background: transparent;
}

.android-container {
  margin-top: 0px !important;
}
.breadcrumb {
  margin-bottom: 0rem;
}
.display-none {
  display: none;
  height: 0px;
}
.height-100 {
  height: 100vh !important;
}
.border-bauhof {
  border-top: 1px solid #767373;
}
</style>
